import styled from '@emotion/styled';
import rem from '../../utils/rem/rem';
import { StyledLinkProps } from './LinkListCard.types';

export const Card = styled.div`
  margin: ${rem(32)} 0 0 ${rem(32)};
  width: ${rem(304)};
  border: 1px solid ${({ theme }) => theme.colors.gray400};
  border-radius: ${rem(8)};
  overflow: hidden;
  height: max-content;
`;

export const CardHeader = styled.div`
  padding: ${rem(12)} ${rem(16)} ${rem(8)} ${rem(16)};
  font-family: 'Pizza Hut';
  font-weight: 400;
  font-size: ${rem(18)};
  color: ${({ theme }) => theme.colors.gray900};
  background-color: ${({ theme }) => theme.colors.gray100};
`;

export const Links = styled.ul`
  padding: 0 ${rem(20)};
`;

export const Link = styled.li<StyledLinkProps>`
  position: relative;
  text-decoration: none;
  list-style: none;
  color: ${({ theme }) => theme.colors.blue};
  font-family: 'Open Sans';
  font-size: ${rem(14)};
  font-weight: 600;
  padding: ${rem(8)} ${rem(4)};
  text-align: start;
  text-transform: uppercase;
  margin: ${rem(8)} 0;
  position: relative;

  &:after {
    position: absolute;
    display: inline-block;
    width: 100%;
    box-sizing: border-box;
    height: 1px;
    background-color: ${({ theme }) => theme.colors.gray400};
    bottom: -4px;
    left: 0;
    ${({ showDivider }) => (showDivider ? `content: '';` : '')}
  }

  &:hover {
    background-color: ${({ theme }) => theme.colors.blueHover};
    outline: none;
  }

  &:focus-within {
    ${({ theme }) => theme.states.focus};
  }

  a {
    text-decoration: none;
    color: ${({ theme }) => theme.colors.blue};
    display: flex;
    align-items: center;
    width: 100%;
    padding: ${rem(4)} 0;

    svg {
      margin-left: ${rem(16)};
    }

    &:focus {
      outline: none;
    }
  }
`;

export const Divider = styled.div`
  width: 100%;
  margin: 0 ${rem(4)};
  box-sizing: border-box;
  height: 1px;
  background-color: ${({ theme }) => theme.colors.gray400};
`;
